import { render, staticRenderFns } from "./CardScaffoldGroups.vue?vue&type=template&id=6a430391"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a430391')) {
      api.createRecord('6a430391', component.options)
    } else {
      api.reload('6a430391', component.options)
    }
    module.hot.accept("./CardScaffoldGroups.vue?vue&type=template&id=6a430391", function () {
      api.rerender('6a430391', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardScaffoldGroups.vue"
export default component.exports